import './styles/globals.scss';
import './dropdown';
import { Modal } from './modal';

window.Modal = Modal;